module.exports = "<md-dialog style=width:400px> <form name=settingsForm> <md-dialog-content> <div layout=column class=md-dialog-content> <md-input-container> <label translate>EMAIL</label> <input type=text required ng-model=$ctrl.requestResetPasswordData.email> </md-input-container> </div> </md-dialog-content> <md-dialog-actions layout=row> <md-button ng-click=$ctrl.cancel()> <span translate>CANCEL</span> </md-button> <md-button ng-click=$ctrl.apply()> <span translate>SEND</span> </md-button> </md-dialog-actions> </form> </md-dialog>";


/*****************
 ** WEBPACK FOOTER
 ** ./app/login/request-reset-password-dialog.html
 ** module id = 339
 ** module chunks = 0
 **/